import React, { createContext, useContext, useState, useEffect } from 'react';
import { app } from '../firebase'; // Importez votre configuration Firebase
import { getAuth} from "firebase/auth";
import { getFirestore, doc, getDoc, query, onSnapshot } from 'firebase/firestore'; 

const auth = getAuth(app);
const db = getFirestore(app);

// Créez un contexte utilisateur
const UserContext = createContext();

// Créez un composant Context Provider
export function UserProvider({ children }) {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true); // Indique si le chargement est en cours
  useEffect(() => {
    // Utilisez Firebase pour surveiller l'état de l'utilisateur
    const unsubscribe = auth.onAuthStateChanged(async (authUser) => {
      setIsLoading(true); // Début du chargement
      if (authUser) {
        //setUser(authUser);

        console.log("onAuthStateChanged"); 
        console.log(authUser.uid);

        // Remplacez 'votre_collection' par le nom de votre collection Firestore
        // et 'votre_document' par l'ID du document que vous souhaitez récupérer.
        const docRef = doc(db, 'users', authUser.uid);

        let data = await fetchDoc(docRef); 

        //on vérifie qu'il s'agit bien d'un compte de type "admin" ou "copropriete" ou "prestataire"
        if(data.status === "copropriete" || data.status === "admin" || data.status === "prestataire" || data.status === "gestionnaireLocatif"){
          let obj = {user: authUser, userData: data};

          if(data.lastCoownershipLoaded){
            const docCoownershipLoadedRef = doc(db, data.lastCoownershipLoaded.path);

            let coownershipData = await fetchDoc(docCoownershipLoadedRef); 

            if(coownershipData){
              obj.userData.isLastCoownershipDeactivated = coownershipData.status !== "activated";

              if(coownershipData.name){              
                obj.userData.nameCoownershipLoaded = coownershipData.name; 
                obj.userData.codeOwner = coownershipData.codeOwner;
                obj.userData.rentalManagerCreateContent = coownershipData.rentalManagerCreateContent ?? false;
              }
            } else {
              obj.userData.isLastCoownershipDeactivated = true;
            }
          } else {
            obj.userData.isLastCoownershipDeactivated = false;
          }

          //on update le contexte de l'utilisateur 
          setUser(obj);
        }else {
          setUser(null);

          await auth.signOut(); // Déconnectez l'utilisateur
        }
      } else {
        setUser(null);
      }
      setIsLoading(false); // Fin du chargement
    });

    // Nettoyez l'effet lors du démontage du composant
    return () => unsubscribe();
  }, []);


  return (
    <UserContext.Provider value={{user:user, isLoading:isLoading, setUser: setUser}}>
      {children}
    </UserContext.Provider>
  );
}


// Récupérez le document Firestore
export const fetchDoc = async (docRef) => {
  try {
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      // Le document existe, vous pouvez accéder à ses données
      return docSnap.data();
    } else {
      // Le document n'existe pas
      console.log('Document not found!');
      return null; 
    }
  } catch (error) {
    console.error('Error fetching document:', error);
    return null; 
  }
};


// Créez un hook personnalisé pour accéder au contexte utilisateur
export function useUser() {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error("useUser doit être utilisé à l'intérieur d'un UserProvider");
  }
  return context;
}


export const isAdmin = (user) => {
  return user.userData.status === "admin";
}

export const isCoownership = (user) => {
  return user.userData.status === "copropriete";
}

export const isProvider = (user) => {
  return user.userData.status === "prestataire";
}

export const isRentalManager = (user) => {
  return user.userData.status === "gestionnaireLocatif";
}

/**
 * Prestataire / gestionnaire locatif / syndic qui doivent choisir une copropriété
 * (aucune copro active, ou copro active désactivée)
 */
export const mustChooseCoownership = (user) => {
  if (!user?.userData) return false;
  if (!isProvider(user) && !isRentalManager(user) && !isCoownership(user)) return false;

  return (
    user.userData.lastCoownershipLoaded == null ||
    user.userData.isLastCoownershipDeactivated === true
  );
}